import { ISupplies, ISupplyStockActivity } from '../../interfaces/Store';
import {
  useInfiniteQuery,
  useQuery,
} from '@tanstack/react-query';
import { getSuppliesV2, getSupplyByIdV2, getSupplyHistoryV2 } from '../../services/supplies.service';

export const useGetSupplies = (enabled: boolean, storeId: string) => useQuery<ISupplies[]>({
  queryKey: ['supplies', { storeId: storeId }],
  enabled: enabled,
  queryFn: async ({ queryKey }) => {
    try {
      const [_key, { storeId }] = queryKey
      const res = await getSuppliesV2(storeId);
      if (!res?.data?.data?.supplies?.supplies) {
        throw new Error('Oh no! Something went wrong while fetching.');
      }
      return res.data.data.supplies.supplies;
    } catch (e: any) {
      console.log('error caught', e['response']?.data?.['errors']);
      throw e;
    }
  }
});

export const useGetSupplyById = (storeId: string, id: string) => useQuery<ISupplies>({
  queryKey: ['supply', { _id: id }],
  enabled: !!storeId,
  queryFn: async ({ queryKey }) => {
    try {
      const [_key, { _id: _id }] = queryKey;
      const res = await getSupplyByIdV2(storeId, _id);
      if (!res?.data?.data) {
        throw new Error('Oh no! Something went wrong while fetching.');
      }
      return res.data.data;
    } catch (e: any) {
      console.log('error caught', e['response']?.data?.['errors']);
      throw e;
    }
  }
});

export const useGetSupplyHistory = (storeId: string, id: string, limit: number) => useInfiniteQuery<ISupplyStockActivity[]>({
  queryKey: ['supplyHistory', { _id: id }],
  enabled: !!storeId,
  initialPageParam: 0,
  getNextPageParam: (lastPage, allPages, lastPageParam) => {
    if (lastPage.length === 0) {
      return undefined
    }
    return lastPageParam + 1
  },
  getPreviousPageParam: (firstPage, allPages, firstPageParam) => {
    if ((firstPageParam as number) <= 1) {
      return undefined
    }
    return (firstPageParam as number) - 1
  },
  queryFn: async ({ queryKey, pageParam }: any) => {
    try {
      const [_key, { _id: _id }] = queryKey;
      const res = await getSupplyHistoryV2(storeId, _id, {
        pageNum: pageParam,
        limit: limit
      });

      if (!res?.data?.data?.history?.supplyActivityHistory) {
        throw new Error('Oh no! Something went wrong while fetching.');
      }
      return res.data.data.history.supplyActivityHistory;
    } catch (e: any) {
      console.log('error caught', e['response']?.data?.['errors']);
      throw e;
    }
  }
});
